import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../actions";
import {
  uniqueArray,
  extractKeyFromArray,
  getSearch,
  setSearch,
  getSorter,
  setSorter,
} from "lib/helper";
import {
  ListAction,
  DeleteListModal,
  DeleteBadge,
  ImportExportBtn,
  AddBtn,
  UploadModal,
  PageTitle,
} from "lib/widget";

import { Table, Input, Row, Col, message, Spin, notification } from "antd";

const Search = Input.Search;

class BrandList extends Component {

  static getDerivedStateFromProps(nextProps, prevState) {
    const { alertMessage, errorMessage, errorImport } = nextProps.brands;
    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }

    if (errorImport !== "") {
      return { errorImport: errorImport };
    }

    return null;
  }

  state = {
    page: 1,
    limit: 20,
    sorter: null,
    removeData: [],
    visible: false,
    visibleDelete: false,
    visibleImport: false,
    file: null,
    fileList: [],
    uploading: false,
  };

  fetchData = () => {
    const { page, limit, keyword, sorter } = this.state
    setSearch(keyword)
    setSorter(sorter)
    this.props.loadBrands(page, limit, keyword, sorter);
  }

  onSearch(value) {
    this.setState({ keyword: value, page: 1 }, this.fetchData);
  }

  onChangePage = (pagination, filters, sorter) => {
    const { order, field } = sorter;
    const { current, pageSize } = pagination;
    this.setState({ page: current, limit: pageSize, sorter: { order, field } }, this.fetchData);
  };

  componentDidMount() {
    this.setState({ keyword: getSearch(), sorter: getSorter() }, this.fetchData)
  }

  componentDidUpdate(prevProps, prevState) {
    const { alertMessage, errorMessage, errorImport } = this.props.brands;
    const prevMsg = prevProps.brands;

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      this.setState({ visibleImport: false });
      message.success(alertMessage);
    }

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      message.error(errorMessage);
    }

    if (errorImport !== "" && prevMsg.errorImport !== errorImport) {
      this.openNotification(errorImport);
    }
  }

  openNotification = (message) => {
    notification.error({
      message: "Import fail",
      description: message,
      duration: 0,
    });
  };

  deleteBrand(id) {
    this.props.deleteBrand(id);
  }

  showModalImport = () => {
    this.setState({
      visibleImport: true,
    });
  };

  handleCancel = () => {
    this.setState({ visibleImport: false });
  };

  onChooseFile = ({ file }) => {
    if (file.status !== "removed") {
      this.setState({ file, fileList: [file] });
    }
  };

  onRemove = () => {
    this.setState({ fileList: [], file: null });
  };

  handleUpload = () => {
    const { page, limit, keyword, file } = this.state;
    this.props.upload(file, page, limit, keyword);
    this.setState({ file: null, fileList: [] });
  };

  onSelectChange = (selectedRowKeys) => {
    let items = selectedRowKeys;

    if (selectedRowKeys.length > 0) {
      let removeData = this.props.brands.data.filter((x) =>
        selectedRowKeys.includes(x.product_brand_id)
      );

      let removeState = this.state.removeData.filter((x) =>
        selectedRowKeys.includes(x.product_brand_id)
      );
      items = uniqueArray([...removeState, ...removeData], "product_brand_id");
    }

    this.setState({ selectedRowKeys, removeData: items }, this.showDrawer);
  };

  handleDrawerClose = (name) => () => {
    this.setState({
      [name]: false,
    });
  };

  showDrawer = (name) => () => {
    this.setState({
      [name]: true,
    });
  };

  handleRemove = () => {
    this.props.destroyMany(
      extractKeyFromArray(this.state.removeData, "product_brand_id")
    );
    this.setState({
      selectedRowKeys: [],
      removeData: [],
      visibleDelete: false,
    });
  };

  handleRemoveAllItem = () => {
    this.setState({ selectedRowKeys: [], removeData: [] });
  };

  handleRemoveItem = (id) => {
    let item = this.state.selectedRowKeys.filter((x) => id !== x);
    let removeData = this.state.removeData.filter(
      (x) => x.product_brand_id !== id
    );
    this.setState({ selectedRowKeys: item, removeData });
  };

  render() {
    const { brands } = this.props;
    const { selectedRowKeys, sorter } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const actionCol = [
      {
        title: "",
        key: "product_brand_id",
        className: "column-action",
        width: window.innerWidth <= 500 ? 40 : 105,
        fixed: "left",
        render: (brands) => (
          <ListAction
            editUrl={`/product/brands/edit/${brands.product_brand_id}`}
            onDelete={this.props.deleteBrand}
            id={brands.product_brand_id}
            name="product_brands"
            breakpoint={500}
          />
        ),
      },
    ];

    const numberCol = [
      {
        title: "#",
        key: "index",
        className: "align-center",
        width: 50,
        render: (text, record, index) =>
          this.state.limit * (this.state.page - 1) + index + 1,
      },
    ];

    const mainColumns = [
      {
        title: "Code",
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'product_brand_code' ? sorter.order : false,
        dataIndex: "product_brand_code",
        width: 140,
      },
      {
        title: "Name",
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'product_brand' ? sorter.order : false,
        dataIndex: "product_brand",
      },
    ];

    const columns =
      window.innerWidth <= 500
        ? [...actionCol, ...mainColumns]
        : [...numberCol, ...mainColumns, ...actionCol];

    return (
      <div>
        <Spin size="large" spinning={this.props.brands.loading}>
          <div style={{ marginBottom: 16 }}>
            <PageTitle
              name="product_brands"
              component={
                <AddBtn url="/product/brands/new" name="product_brands" />
              }
            />
            <Row gutter={[16, 16]}>
              <DeleteBadge
                count={this.state.removeData.length}
                onClick={this.showDrawer("visibleDelete")}
              />
              <Col xs={8} sm={8} md={8} lg={6} className="import-btn-align">
                <ImportExportBtn
                  showModalImport={this.showModalImport}
                  download={this.props.download}
                  name="product_brands"
                />
              </Col>
              <Col
                xs={13}
                sm={13}
                md={{ span: 8, offset: 6 }}
                lg={{ span: 8, offset: 9 }}
              >
                <Search
                  defaultValue={getSearch()}
                  placeholder="Search for code or name"
                  onSearch={(value) => this.onSearch(value)}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            <DeleteListModal
              onClose={this.handleDrawerClose}
              visible={this.state.visibleDelete}
              data={this.state.removeData}
              onRemove={this.handleRemove}
              removeItem={this.handleRemoveItem}
              removeAllItem={this.handleRemoveAllItem}
              displayKey={[
                "product_brand_id",
                "product_brand_code",
                "product_brand",
              ]}
            />
          </div>
          <Table
            rowKey="product_brand_id"
            bordered={true}
            size="small"
            columns={columns}
            rowSelection={rowSelection}
            dataSource={brands.data}
            pagination={{
              pageSize: this.state.limit,
              total: brands.totalSize,
              current: this.state.page,
            }}
            onChange={this.onChangePage}
            scroll={window.innerWidth <= 500 ? { x: 500 } : undefined}
          />

          <UploadModal
            visibleImport={this.state.visibleImport}
            handleCancel={this.handleCancel}
            loading={this.props.brands.loading}
            onChooseFile={this.onChooseFile}
            fileList={this.state.fileList}
            onRemove={this.onRemove}
            handleUpload={this.handleUpload}
            uploading={this.state.uploading}
            disabled={this.state.file ? false : true}
          />
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = ({ brands }) => ({
  brands,
});

const mapDispatchToProps = {
  loadBrands: actions.loadBrands.request,
  deleteBrand: actions.deleteBrand.request,
  download: actions.download.request,
  upload: actions.upload.request,
  destroyMany: actions.destroyMany.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandList);
